import { create } from "zustand";

type CollapseState = {
    collapsed: boolean;
    hudWidth: number,
    toggle: () => void;
    setCollapsed: (v: boolean) => void;
};

export const useHudCollapse = create<CollapseState>((set) => ({
    collapsed: false,
    hudWidth: 240,
    toggle: () => set((s) => ({ collapsed: !s.collapsed, hudWidth: s.collapsed ? 240 : 48 })),
    setCollapsed: (v) => set({ collapsed: v }),
}));
